var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.13281 4.26667V11.7333C2.13281 12.0279 2.37159 12.2667 2.66615 12.2667H13.3328C13.6274 12.2667 13.8661 12.0279 13.8661 11.7333V4.26667C13.8661 3.97212 13.6274 3.73334 13.3328 3.73334H2.66615C2.37159 3.73334 2.13281 3.97212 2.13281 4.26667ZM4.44392 4.8H11.555H11.9966L7.99938 8.35309L4.00215 4.8H4.44392ZM3.19948 5.51367V11.2H12.7995V5.51349L8.70803 9.15033C8.30389 9.50957 7.69487 9.50957 7.29072 9.15033L3.19948 5.51367ZM12.7995 4.80012V4.8H12.7994L12.7995 4.80012Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a635c1644573e639972f72b19c46e581.svg";
export { ForwardRef as ReactComponent };